import React from 'react';
import {useSelector} from 'react-redux';
import Loader from '@bonprix/pattern-library/templates/loader/default';
import {selectFilterLoadingbarStatus, selectLoadingbarStatus} from '../../LoaderSlice.jsx';
import {useBreakpointUp} from "bonprix-design-system";

export default function SideSheetLoader() {
    const breakpointLUp = useBreakpointUp('l');
    const loader = useSelector(selectLoadingbarStatus);
    const filterLoader = useSelector(selectFilterLoadingbarStatus);
    if (loader.status || (breakpointLUp && filterLoader.status)) {
        return (
            <div className="filter-side-sheet__loader-wrapper">
                {(loader.defaultCase || filterLoader.status) && <Loader className={'article-overview__loader'} />}
            </div>
        );
    } else {
        return <></>;
    }
}
